export interface IUpsellBodyText {
  header?: string;
  text: string;
}

export const UpsellBodyText = (props: IUpsellBodyText) => {
  const { header, text } = props;
  return (
    <div>
      {header && (
        <h3
          automation-id="upsell-message-information-header"
          className="font-sans text-p-16 font-bold leading-normal"
        >
          {header}
        </h3>
      )}
      <p
        automation-id="upsell-message-information-body"
        className="whitespace-pre-line font-sans text-p-16 font-medium leading-normal"
      >
        {text}
      </p>
    </div>
  );
};
